import React, { useState } from 'react'
import LoginForm from './components/LoginForm';
import RegisterForm from './components/RegisterForm';
import ForgotPasswordForm from './components/ForgotPasswordForm';

const LoginPage = () => {
    // view: 'login' | 'register' | 'forgot'
    const [view, setView] = useState('login');

    return (
        <>
            {view === 'login' && <LoginForm setView={setView} />}
            {view === 'register' && <RegisterForm setView={setView} />}
            {view === 'forgot' && <ForgotPasswordForm setView={setView} />}
        </>
    )
}

export default LoginPage
